exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-select[data-v-64c7ca5d]{height:34px!important;border-radius:3px!important;padding:1px 8px}.small-description[data-v-64c7ca5d]{line-height:11px}.b-group-item-end[data-v-64c7ca5d]{display:flex!important;justify-content:space-between!important}.b-group-item-end b[data-v-64c7ca5d]{text-transform:none}", ""]);

// exports
